import { createSlice } from "@reduxjs/toolkit";
import { Profile } from "../@types/profile";

export interface IProfileState {
  profile?: Profile;
}

const initialState: IProfileState = {};

const profileSlice = createSlice({
  name: "profile",
  initialState: initialState,
  reducers: {
    add(state, action) {
      state.profile = action.payload as Profile;
      return state;
    },
    enableCashAdvance(state) {
      if (state.profile) {
        state.profile.subscription.cashAdvanceEnabled = true;
      }
      return state;
    },
  },
});

export const { add, enableCashAdvance } = profileSlice.actions;
export default profileSlice.reducer;
